import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChatMentionRender, renderChatMarkdown } from './chat-markdown.renderer';

/**
 * Internal Chat markdown pipe (SPEC-2026-07-internal-chat, T-19) — renders the
 * chat markdown subset to sanitized HTML for `[innerHTML]` bindings.
 *
 * Declared in ChatSharedModule so the popup quick-reply and the `/chat` full
 * view share ONE renderer. The heavy lifting (escape-first + subset render)
 * lives in the pure `renderChatMarkdown` (see chat-markdown.renderer.ts);
 * `bypassSecurityTrustHtml` is safe here because the renderer escapes ALL
 * input before emitting its own fixed tag set (http(s)-only anchors).
 */
@Pipe({
  name: 'chatMarkdown',
  standalone: false,
})
export class ChatMarkdownPipe implements PipeTransform {

  constructor(private readonly sanitizer: DomSanitizer) { }

  /**
   * `mentions` (optional) turns the `@Name` tokens of the message into
   * highlighted chips — the renderer escapes the names, so the security
   * contract above is unchanged.
   */
  transform(content: string | null | undefined, mentions?: ChatMentionRender[]): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(renderChatMarkdown(content ?? '', mentions));
  }
}
